import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import {
  SearchResult,
  TableQuery,
  buildPaginacaoParams,
} from '@/app/core/service/table.service'
import { environment } from '@environment/environment'
import {
  InstituicaoDto,
  InstituicaoCadastroPayload,
  InstituicaoEdicaoPayload,
} from '../models/instituicao.model'

export type { InstituicaoDto, InstituicaoCadastroPayload, InstituicaoEdicaoPayload }

@Injectable({ providedIn: 'root' })
export class InstituicaoService {
  private readonly apiUrl = `${environment.basePath}/instituicoes`
  private http = inject(HttpClient)

  listarPaginado(
    query: TableQuery<InstituicaoDto>
  ): Observable<SearchResult<InstituicaoDto>> {
    const params = buildPaginacaoParams(query)

    return this.http.get<SearchResult<InstituicaoDto>>(this.apiUrl, { params })
  }

  obterPorId(id: number): Observable<InstituicaoDto> {
    return this.http.get<InstituicaoDto>(`${this.apiUrl}/${id}`)
  }

  cadastrar(payload: InstituicaoCadastroPayload): Observable<void> {
    return this.http.post<void>(this.apiUrl, payload)
  }

  atualizar(id: number, payload: InstituicaoEdicaoPayload): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, payload)
  }

  obterGrupoListaIdPadrao(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/padrao/grupo-lista-id`)
  }
}
